export default {
  primary: '#51b84b',
  secondary: '#424242',
  accent: '#82B1FF',
  error: '#FF3739',
  info: '#00D0BD',
  success: '#5D92F4',
  warning: '#FFB70F',
  base: '#ffffff'
}